
import React, { useState } from "react";
import { Tabs } from "@/components/ui/tabs";
import { mockOrders, mockReportData } from "@/data/mockData";
import ReportHeader from "@/components/reports/ReportHeader";
import ReportTabsList from "@/components/reports/ReportTabsList";
import ReportTabContent from "@/components/reports/ReportTabContent";
import reportTabs from "@/components/reports/ReportTabs";

const Reports = () => {
  const [timePeriod, setTimePeriod] = useState('month');
  const [activeTab, setActiveTab] = useState('naleveringen');

  return (
    <div className="space-y-6">
      <ReportHeader 
        timePeriod={timePeriod} 
        setTimePeriod={setTimePeriod} 
      />

      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <ReportTabsList tabs={reportTabs} />
        <ReportTabContent activeTab={activeTab} />
      </Tabs>
    </div>
  );
};

export default Reports;
